import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { AllocationValue } from '@/components/finance/BUAllocationEditor';
import { toast } from 'sonner';

export const usePaymentRequestAllocations = (paymentRequestId?: string | null) => {
  return useQuery({
    queryKey: ['payment-request-allocations', paymentRequestId],
    enabled: !!paymentRequestId,
    queryFn: async (): Promise<AllocationValue[]> => {
      const { data, error } = await (supabase as any)
        .from('payment_request_bu_allocations')
        .select('business_unit, percentage')
        .eq('payment_request_id', paymentRequestId);
      if (error) throw error;
      return (data || []).map((r: any) => ({
        business_unit: r.business_unit,
        percentage: Number(r.percentage),
      }));
    },
  });
};

export const useSavePaymentRequestAllocations = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      paymentRequestId,
      allocations,
    }: {
      paymentRequestId: string;
      allocations: AllocationValue[];
    }) => {
      const { error } = await (supabase as any).rpc('set_payment_request_bu_allocations', {
        p_payment_request_id: paymentRequestId,
        p_allocations: allocations,
      });
      if (error) throw error;
    },
    onSuccess: (_d, vars) => {
      qc.invalidateQueries({ queryKey: ['payment-request-allocations', vars.paymentRequestId] });
      toast.success('Business unit allocations saved');
    },
    onError: (e: any) => toast.error(e.message || 'Failed to save allocations'),
  });
};
